<div class="py-4">
  <mat-card class="px-3">
    <mat-card-header
      class="flex align-items-center mb-3 sm:mb-0 lg:mb-0 xl:mb-0">
      <shared-title>Reportes de lugares más ocupados</shared-title>
      <button
        mat-icon-button
        matTooltip="Limpiar formulario"
        matTooltipPosition="right"
        class="ml-5"
        (click)="clearForm()">
        <mat-icon>cleaning_services</mat-icon>
      </button>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="formReports" (submit)="submit()">
        <div class="grid">
          @if (isrole) {
            <mat-form-field
              class="col-12 ms:col-12 md:col-6 lg:col-6 xl:col-6"
              appearance="outline">
              <mat-label>Empresas</mat-label>
              <input
                type="text"
                aria-label="text"
                matInput
                [(ngModel)]="selectedBussinesName"
                [formControl]="myControl"
                [disabled]="!ValidBusiness_id()"
                [matAutocomplete]="auto"
                (keydown)="onKeyDown($event)" />
              <mat-autocomplete
                autoActiveFirstOption
                #auto="matAutocomplete"
                (optionSelected)="
                  onOptionSelected($event.option.value, $event.option.viewValue)
                "
                (optionSelected)="chargueDataForm()">
                @for (option of filteredOptions | async; track option) {
                  <mat-option [value]="option.idBusiness">{{
                    option.name
                  }}</mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          } @else {
            <mat-form-field
              class="col-12 ms:col-12 md:col-6 lg:col-6 xl:col-6"
              appearance="outline">
              <mat-label>Empresa</mat-label>
              <mat-select
                required
                [disabled]="!ValidBusiness_id()"
                (selectionChange)="chargueDataForm()"
                [(value)]="selectedBussines">
                @for (item of bussines; track item) {
                  <mat-option [value]="item.idBusiness">{{
                    item.name
                  }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          <mat-form-field
            class="col-12 ms:col-12 md:col-6 lg:col-6 xl:col-6"
            appearance="outline">
            <mat-label>Seleccione el rango</mat-label>
            <mat-date-range-input [rangePicker]="rangePicker">
              <input
                matStartDate
                placeholder="Fecha Inicial"
                formControlName="startDate"
                readonly />
              <input
                matEndDate
                placeholder="Fecha Final"
                formControlName="endDate"
                readonly />
            </mat-date-range-input>

            <mat-datepicker-toggle
              matIconSuffix
              [for]="rangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #rangePicker>
              <mat-date-range-picker-actions>
                <button mat-button matDateRangePickerCancel>Cancel</button>
                <button
                  mat-raised-button
                  color="primary"
                  matDateRangePickerApply>
                  Elegir
                </button>
              </mat-date-range-picker-actions>
            </mat-date-range-picker>
          </mat-form-field>

          <mat-form-field
            class="col-12 ms:col-12 md:col-6 lg:col-6 xl:col-6"
            appearance="outline">
            <mat-label>Tipo de puesto</mat-label>
            <mat-select formControlName="workplaceTypeId">
              @for (workplace of ptypeJobs; track workplace) {
                <mat-option
                  [value]="workplace.workplacetypeid"
                  (click)="filterWorkplacesByTypeId(workplace.workplacetypeid)">
                  {{ workplace.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field
            class="col-12 ms:col-12 md:col-6 lg:col-6 xl:col-6"
            appearance="outline">
            <mat-label>Edificio</mat-label>
            <mat-select formControlName="buildingId">
              @for (building of buildings; track building) {
                <mat-option
                  [value]="building.buildingid"
                  (click)="chargueFloorByBuilding(building.buildingid)">
                  {{ building.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field
            class="col-12 ms:col-12 md:col-6 lg:col-6 xl:col-6"
            appearance="outline">
            <mat-label>Nivel</mat-label>
            <mat-select formControlName="floorId">
              @for (item of floors; track item) {
                <mat-option
                  [value]="item.floorid"
                  (click)="chargueWorkplaces(item.floorid)"
                  >{{ item.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field
            class="col-12 ms:col-12 md:col-6 lg:col-6 xl:col-6"
            appearance="outline">
            <mat-label>Puesto de Trabajo</mat-label>
            <mat-select formControlName="workplaceId">
              @for (workplace of workplacesFilter(); track workplace) {
                <mat-option [value]="workplace.workplaceid"
                  >{{ workplace.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field
            class="col-12 ms:col-12 md:col-6 lg:col-6 xl:col-6"
            appearance="outline">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="worker" />
          </mat-form-field>
        </div>

        <div class="grid">
          <shared-button
            [icon]="'search'"
            [typeBtn]="'button'"
            (click)="findData()"
            [disabled]="!ValidForms()"
            color="accent"
            class="col-fixed">
            Buscar
          </shared-button>

          <div class="col flex gap-3 justify-content-end">
            <shared-button
              [icon]="'save_alt'"
              [typeBtn]="'button'"
              (click)="downloadCsv()"
              [disabled]="!ValidForms()"
              color="accent">
              Descargar CSV
            </shared-button>
            <shared-button
              [icon]="'save_alt'"
              [typeBtn]="'button'"
              (click)="downloadPDF()"
              [disabled]="!ValidForms()"
              color="accent">
              Descargar PDF
            </shared-button>
          </div>
        </div>
      </form>
      <br />
      <div class="shadow-2 overflow-auto">
        <table mat-table [dataSource]="dataSource">
          <!-- Date Column -->
          <ng-container matColumnDef="building" sticky>
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Edificio</th>
            <td mat-cell *matCellDef="let element">{{ element.edificio }}</td>
          </ng-container>
          <!-- Date Column -->
          <ng-container matColumnDef="floor" sticky>
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nivel</th>
            <td mat-cell *matCellDef="let element">{{ element.nivel }}</td>
          </ng-container>
          <!-- User Column -->
          <ng-container matColumnDef="workplace">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Puestos de trabajo
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.puesto }}
            </td>
          </ng-container>
          <!-- Name Column -->
          <ng-container matColumnDef="frequency">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Frecuencia
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.frecuencia }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <br />
      <mat-paginator
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons
        aria-label="Select page of periodic elements">
      </mat-paginator>
    </mat-card-content>
  </mat-card>
</div>
